import React from 'react';
import Medicine from '../Medicine/Medicine';

const PharmacyHome = () => {
    return (
        <div>
            <Medicine />


        </div>
    );
};

export default PharmacyHome;
